var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quill-editor',{attrs:{"value":_vm.content,"options":{
    modules: {
      toolbar: [
        [{ header: [2, false] }],
        ['bold', 'italic', 'underline', 'link'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        ['clean'] ],
    },
  }},on:{"change":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }